module.exports = __webpack_public_path__ + "static/media/rio-de-janeiro-5.32c81958.jpg";